<template>
    <footer class="footer t-blue">
        <div class="grid">
            <div class="col-3 md footer__contact">
                <router-link :to="'/' + $route.params.lang + '/'">
                    <img src="~@/assets/logo.png">
                </router-link>
                <p><a :href="$t('tel')">{{ $t('phoneNumber') }}</a><br><a href="mailto:info@education-cloud.eu">info@education-cloud.eu</a></p>
            </div>
            <div class="col-2 md footer__nav">
                <router-link :to="'/' + $route.params.lang + '/configurator'" exact v-on:click.native="scrollToTop()">Konfigurator</router-link><br>
                <router-link :to="'/' + $route.params.lang + '/training'" exact v-on:click.native="scrollToTop()">Schulungen</router-link><br>
                <router-link :to="'/' + $route.params.lang + '/inspirations'" exact v-on:click.native="scrollToTop()">Inspirationen</router-link><br>
                <router-link :to="'/' + $route.params.lang + '/questions'" exact v-on:click.native="scrollToTop()">Fragen</router-link><br>
                <router-link :to="'/' + $route.params.lang + '/glossary'" exact v-on:click.native="scrollToTop()">Glossar</router-link><br>
                <router-link
                    v-for="page in getNav('footerLeft')"
                    :key="page.id"
                    :to="page.slug"
                    v-on:click.native="scrollToTop()"
                >{{ page.title }}<br></router-link>

            </div>
            <div class="col-1 md footer__nav">
                <router-link
                    v-for="page in getNav('footerRight')"
                    :key="page.id"
                    :to="'/' + $route.params.lang + '/' + page.slug"
                    exact
                    v-on:click.native="scrollToTop()"
                >{{ page.title }}<br></router-link>
            </div>
            <div class="col-6 md footer__dsgv">
                <div>
                    <img src="~@/assets/dsgvo.png">
                    <div class="content">
                        <h2>{{ $t('regulation title') }}</h2>
                        <p>{{ $t('regulation description') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        computed: {
            pages(){
                return this.$store.state.pages.pages
            }
        },
        methods: {
            getNav(side) {
                let sites = []
                this.pages.forEach(function(element){
                    if(element.visibility == side) {
                        sites.push(element)
                    }
                })
                return sites
            },
            scrollToTop() {
                window.scrollTo(0,0);
            }
        }
    }
</script>

<style scoped lang="scss">
    .footer {
        position: relative;
        width: 100%;
        overflow: hidden;
        background-image: url("~@/assets/cloud.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: right;
        padding: 40px;
        font-weight: 600;

        &__contact {
            img {
                max-width: 190px;
            }
            p {
                padding-left: 90px;
            }
        }

        &__nav {
            a {
                text-decoration: none;
                transition: 0.3s all ease;
            }
            a:hover {
                color: $orange;
            }
        }

        &__dsgv {
            display: flex;
            justify-content: right;
            h2 {
                margin-bottom: 0;
                margin-top: 0;
            }
            img {
                float: left;
                width: 140px;
                margin-top: -10px;
            }
        }
        .content {
            vertical-align: middle;
            display: table;
        }
    }

    @media (max-width: 1600px){
        .footer {
            background-size: cover;
        }
    }

    @media (max-width: 1200px){
        .footer__nav {
            margin-left: 90px;
            margin-top: 20px;
        }

        .footer__dsgv {
            display: block;
            margin-left: 70px;
            margin-top: 20px;
        }
    }

    @media (max-width: 950px) {
        .footer__contact,
        .footer__nav,
        .footer__dsgv {
            text-align: center;
            margin: 20px 0;
            padding: 0;
        }
        .footer__contact p {
            padding: 0;
        }
        .footer__dsgv img {
          float: none;
        }
        .footer .content {
          display: block;
        }
    }
</style>
